import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsSvgjs="http://svgjs.dev/svgjs"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      viewBox="0 0 2000 227"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="2000"
        height="227"
        data-background-color="#ffffff"
        transform="translate(-1.212 -.746)"
        viewBox="0 0 396 45"
      >
        <svg
          width="395.52"
          height="44.704"
          transform="translate(.24 .148)"
          viewBox="0 0 395.52 44.704"
        >
          <svg width="395.52" height="44.704" viewBox="0 0 395.52 44.704">
            <svg width="395.52" height="44.704" viewBox="0 0 395.52 44.704">
              <svg width="395.52" height="44.704" viewBox="0 0 395.52 44.704">
                <svg width="395.52" height="44.704" viewBox="0 0 395.52 44.704">
                  <svg
                    width="395.52"
                    height="44.704"
                    data-palette-color="#a022ff"
                    viewBox="3.5 -33.7 301.68 34.1"
                  >
                    <path
                      fill="#a022ff"
                      d="M7.55 0H3.5l2.45-33.7h5.15l4.45 12.3 5.4 15.7q2.9-8.2 5.7-15.7l4.65-12.3h5.15L39.4 0h-4.05L34.2-13.3 33-28.25q-2.65 7.4-5.45 14.95L22.85-.75H19L14.55-13.3l-5.1-14.65q0 1.95-.95 14.65L7.55 0zm46.2-14.2l-.65 1.9h11.95l-.65-1.95-5.25-16.2q-.6 2.15-5.4 16.25zM73.5 0h-4.35L66.2-8.85H51.95l-3 8.85H44.6l11.75-33.7h5.6L73.5 0zm4.59-33.7h22.25v3.3L82.55-3.45h18.54V0H77.84v-3.35l17.81-26.9H78.09v-3.45zm50 21v-21h4.05v20.9q0 6.5-3.27 9.85Q125.59.4 119.74.4q-5.75 0-9-3.28-3.25-3.27-3.25-9.52v-21.3h4.05v21.25q0 4.65 2.23 6.85 2.22 2.2 5.97 2.2 8.35 0 8.35-9.3zm20.4-17.5h-4.65v13.45h5.1q3.45 0 5.28-1.88 1.82-1.87 1.82-4.82 0-6.75-7.55-6.75zm4.85 16.25L162.19 0h-4.85l-8.25-13.3h-5.25V0h-4.05v-33.7h8.45q5.85 0 8.88 2.75 3.02 2.75 3.02 7.6-.1 3.5-1.85 5.95t-4.95 3.45zm17.9-1.1v11.5h14.75V0h-18.8v-33.7h18.55v3.55h-14.5v11.55h12.8v3.55h-12.8zM196.29 0h-4.05v-33.7h4.05V0zm18.65-33.7l-12.85 17.05L215.64 0h-5.25l-13.3-16.65 12.85-17.05h5zm10.04 3.6v26.55h6.05q6.25 0 9.45-3.88 3.2-3.87 3.2-9.67 0-5.5-3.57-9.25-3.58-3.75-9.28-3.75h-5.85zM220.88 0v-33.7h10q7.45 0 12.23 4.62 4.77 4.63 4.77 11.98 0 7.3-4.42 12.2Q239.03 0 231.08 0h-10.2zm37.1-15.05v11.5h14.75V0h-18.8v-33.7h18.55v3.55h-14.5v11.55h12.8v3.55h-12.8zm42.85-18.65h4.35L293.43 0h-5.1l-11.4-33.7h4.35l4.4 13.35 5.25 16.7q1.95-6.3 5.4-16.7l4.5-13.35z"
                      className="undefined-text-0"
                      data-fill-palette-color="primary"
                      opacity="1"
                    ></path>
                  </svg>
                </svg>
              </svg>
            </svg>
          </svg>
        </svg>
      </svg>
    </svg>
  );
}

export default Icon;
